import { AccordionTypes } from '@genial/components';
import { useResetRecoilState, useSetRecoilState } from 'recoil';

import { orderItemState, orderStatusState } from './atom';
import {
  changeOrderStatus,
  orderInteractionChannelAuditRequest,
  orderItem,
  selectOrderChannels,
} from './selectors';
import { OrderData } from './types';

export const useOrderActions = () => {
  const setOrderItem = useSetRecoilState(orderItem);
  const setOrderStatus = useSetRecoilState(changeOrderStatus);
  const setOrderChannels = useSetRecoilState(selectOrderChannels);
  const setOrderInteractionChannelAudit = useSetRecoilState(orderInteractionChannelAuditRequest);

  const clearOrderState = useResetRecoilState(orderItemState);
  const clearOrderStatus = useResetRecoilState(orderStatusState);

  const updateOrderStatus = (newStatus: AccordionTypes.Status) => {
    setOrderStatus(newStatus);
  };

  const handleSelectOrderItem = (item: Partial<OrderData>) => {
    return setOrderItem(item);
  };

  const handleSelectOrderChannels = (channels: string[]) => {
    setOrderChannels(channels);
  };

  const resetOrder = () => {
    clearOrderState();
    clearOrderStatus();
  };

  return {
    handleSelectOrderItem,
    updateOrderStatus,
    resetOrder,
    handleSelectOrderChannels,
    setOrderInteractionChannelAudit,
  };
};
